(() => {
  const selector = '[data-returns-experience]';

  function init(section) {
    if (!section || section.dataset.returnsReady === 'true') return;
    section.dataset.returnsReady = 'true';

    section.querySelectorAll('[data-returns-faq]').forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;

        section.querySelectorAll('[data-returns-faq][open]').forEach((other) => {
          if (other !== item) other.removeAttribute('open');
        });
      });
    });
  }

  function initAll(root = document) {
    if (root.matches?.(selector)) init(root);
    root.querySelectorAll(selector).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
